export function useQueryParams() {
  const search = window?.location?.search || "";
  const urlSearchParams = new URLSearchParams(search);

  return {
    urlSearchParams,
    getValueFromParams: (key) => urlSearchParams.get(key)
  };
}
